module.exports = __webpack_public_path__ + "static/media/download.0fdc8a55.svg";